import { Phone } from "lucide-react";

const NUMBER = "+917004810637"; // Rahul

export default function CallButton() {
  return (
    <a
      href={`tel:${NUMBER}`}
      data-testid="call-fab"
      aria-label="Call Rahul at Tikratoli"
      className="fixed bottom-6 right-[168px] z-40 group inline-flex items-center gap-3 pl-4 pr-5 py-3 bg-[#D97645] hover:bg-[#C0602F] transition-all duration-300 shadow-lg shadow-black/40 rounded-full"
    >
      <Phone size={20} className="text-white" strokeWidth={2.2} />
      <span className="font-mono-label text-white text-xs tracking-widest">
        Call
      </span>
      <span className="absolute inset-0 rounded-full bg-[#D97645] animate-ping opacity-30 pointer-events-none" />
    </a>
  );
}
